import type { G_PostReviewErrorCode } from "~/lib/graphql";

export const REVIEW_ERROR_TEXT: { [key in G_PostReviewErrorCode]: string } = {
  /** 不明なエラー */
  UNSPECIFIED: "エラーが発生しました。\n暫くしてから再度お試しください。",
  /**  既にレビュー投稿済み  */
  ALREADY_EXISTS: "既にレビューが投稿されています。",
  /**  レビュータイトルが規定文字数の範囲外  */
  INVALID_TITLE: "タイトル文字数の上限を超過しています。",
  /**  投稿内容が規定文字数の範囲外  */
  INVALID_COMMENT: "文字数の上限・下限を超過しています。\n投稿内容の文字数をご確認ください。",
  /**  レビュアー名未登録 かつ レビュアー名が未設定  */
  NO_REVIEWER_NAME: "レビュアー名が未登録です。",
  /**  重複など何らかの理由でレビュアー名が利用不可  */
  UNAVAILABLE_REVIEWER_NAME: "入力されたニックネームは既に存在しています。\n別のニックネームで投稿してください。",
  /**  レビュアー名登録済み かつ レビュアー名が設定されている  */
  REVIEWER_NAME_IS_REGISTERED: "レビュアー名登録済みとなります。",
  /**  禁則文字が含まれているためレビュアー名が利用不可  */
  INVALID_REVIEWER_NAME: "利用できない文字が含まれています。",
  /**  内部エラー  */
  INTERNAL_ERROR: "エラーが発生しました。\n暫くしてから再度お試しください。",
};
